<template>
    <div class="grade-page">
        <!-- 查询筛选卡片 -->
        <el-card shadow="always" class="filter-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <i class="el-icon-collection"></i>
                    <span>年级管理</span>
                    <el-divider direction="vertical"></el-divider>
                    <span class="header-sub">筛选条件</span>
                </div>
            </div>
            <el-form :inline="true" :model="query" class="filter-form">
                <el-form-item label="学段">
                    <el-select v-model="query.stage" placeholder="全部学段" clearable style="width: 120px">
                        <el-option label="小学" :value="1"></el-option>
                        <el-option label="初中" :value="2"></el-option>
                        <el-option label="高中" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="年级名称">
                    <el-input clearable v-model="query.gradeName" placeholder="请输入年级名称" style="width: 160px"></el-input>
                </el-form-item>
<!--                <el-form-item label="年级级别">-->
<!--                    <el-input-number v-model="query.gradeLevel" :min="1" :max="12" controls-position="right" style="width: 140px"></el-input-number>-->
<!--                </el-form-item>-->
                <el-form-item label="状态">
                    <el-select v-model="query.status" placeholder="全部状态" clearable style="width: 120px">
                        <el-option label="启用" :value="1"></el-option>
                        <el-option label="禁用" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 表格卡片 -->
        <el-card shadow="always" class="table-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <span>数据列表</span>
                    <span class="total-badge">共 <b>{{ total }}</b> 条</span>
                </div>
                <div class="card-header-right">
                    <el-button type="success" icon="el-icon-files" @click="openBatchDialog">批量新增</el-button>
                    <el-button type="primary" icon="el-icon-plus" @click="btnInsert(null)">新增年级</el-button>
                </div>
            </div>
            <el-table
                :data="list"
                border
                stripe
                v-loading="tableLoading"
                element-loading-text="加载中..."
                style="width: 100%">
                <el-table-column type="index" label="序号" width="100" align="center"/>
                <el-table-column prop="gradeName" label="年级名称" show-overflow-tooltip/>
                <el-table-column prop="gradeLevel" label="级别" align="center"/>
                <el-table-column prop="stage" label="学段" align="center">
                    <template slot-scope="scope">
                        <el-tag size="small" effect="plain"
                            :type="scope.row.stage === 1 ? 'success' : scope.row.stage === 2 ? 'warning' : 'info'">
                            {{ stageMap[scope.row.stage] || '-' }}
                        </el-tag>
                    </template>
                </el-table-column>
<!--                <el-table-column prop="description" label="描述" min-width="160" show-overflow-tooltip>-->
<!--                    <template slot-scope="scope">-->
<!--                        <span>{{ scope.row.description || '-' }}</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column prop="sort" label="排序" align="center"/>
                <el-table-column prop="status" label="状态" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small" effect="plain">
                            {{ scope.row.status === 1 ? '启用' : '禁用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="170" align="center"/>
                <el-table-column align="center" label="操作" width="180" fixed="right">
                    <template slot-scope="scope">
                        <div class="action-btns">
                            <el-button type="primary" size="mini" icon="el-icon-edit" @click="btnInsert(scope.row)">编辑</el-button>
                            <el-button type="danger" size="mini" icon="el-icon-delete" @click="btnDelete(scope.row.id)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrapper" v-if="total > 0">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="query.currentPage"
                    :page-size="query.pageSize"
                    :total="total">
                </el-pagination>
            </div>
        </el-card>

        <!-- 新增/编辑对话框 -->
        <el-dialog
            :close-on-click-modal="false"
            :visible.sync="dialogVisible"
            width="600px"
            top="8vh"
            :show-close="false"
            @close="closeDialog"
            custom-class="grade-dialog">
            <div slot="title" class="batch-header">
                <div class="batch-header-left">
                    <div class="batch-header-icon"><i class="el-icon-notebook-2"></i></div>
                    <div>
                        <div class="batch-header-title">{{ dialogTitle }}</div>
                        <div class="batch-header-desc">选择学段后级别自动匹配，可微调</div>
                    </div>
                </div>
                <i class="el-icon-close batch-header-close" @click="dialogVisible = false"></i>
            </div>
            <el-form :model="formData" ref="formData" :rules="rules" label-width="80px">
                <el-form-item label="年级名称" prop="gradeName">
                    <el-input v-model="formData.gradeName" maxlength="20" placeholder="例如：七年级"></el-input>
                </el-form-item>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="学段" prop="stage">
                            <el-select v-model="formData.stage" placeholder="请选择" style="width: 100%" @change="onStageChange">
                                <el-option label="小学" :value="1"></el-option>
                                <el-option label="初中" :value="2"></el-option>
                                <el-option label="高中" :value="3"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="年级级别" prop="gradeLevel">
                            <el-input-number v-model="formData.gradeLevel" :min="stageRange.min" :max="stageRange.max" controls-position="right" style="width: 100%"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="描述" prop="description">
                    <el-input type="textarea" v-model="formData.description" maxlength="200" placeholder="请输入描述" :rows="3"></el-input>
                </el-form-item>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="排序" prop="sort">
                            <el-input-number v-model="formData.sort" :min="0" :max="9999" controls-position="right" style="width: 100%"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="状态" prop="status">
                            <el-radio-group v-model="formData.status">
                                <el-radio :label="1">启用</el-radio>
                                <el-radio :label="0">禁用</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm" :loading="submitLoading">确定</el-button>
            </div>
        </el-dialog>

        <!-- 批量新增对话框 -->
        <el-dialog
            :visible.sync="batchDialogVisible"
            width="820px"
            top="8vh"
            :close-on-click-modal="false"
            :show-close="false"
            @close="closeBatchDialog"
            custom-class="batch-grade-dialog">
            <div slot="title" class="batch-header">
                <div class="batch-header-left">
                    <div class="batch-header-icon"><i class="el-icon-notebook-2"></i></div>
                    <div>
                        <div class="batch-header-title">批量新增年级</div>
                        <div class="batch-header-desc">级别与排序自动填充，已存在的年级自动跳过</div>
                    </div>
                </div>
                <i class="el-icon-close batch-header-close" @click="batchDialogVisible = false"></i>
            </div>

            <!-- 快捷操作条 -->
            <div class="batch-quickbar">
                <div class="quick-item">
                    <span class="quick-label">快速选择</span>
                    <el-button size="mini" :type="isAllChecked ? 'primary' : 'default'" @click="toggleAllGrades">
                        {{ isAllChecked ? '取消全选' : '全部年级' }}
                    </el-button>
                    <el-button
                        v-for="sec in stageSections"
                        :key="sec.stage"
                        size="mini"
                        :type="isStageCheckedAll(sec.stage) ? 'primary' : 'default'"
                        @click="toggleStageAll(sec.stage, !isStageCheckedAll(sec.stage))">{{ sec.label }}</el-button>
                </div>
                <span class="batch-count">已选 <b>{{ checkedGrades.length }}</b> 个</span>
            </div>

            <div class="batch-sections">
                <div class="batch-section" v-for="sec in stageSections" :key="sec.stage">
                    <div class="batch-section-head">
                        <span class="batch-section-title" :class="'stage-' + sec.stage">
                            <i class="batch-stage-dot"></i>{{ sec.label }}
                        </span>
                        <el-checkbox
                            :indeterminate="isStageIndeterminate(sec.stage)"
                            :value="isStageCheckedAll(sec.stage)"
                            @change="(val) => toggleStageAll(sec.stage, val)">全选</el-checkbox>
                    </div>
                    <el-checkbox-group v-model="checkedGrades" class="batch-group" @change="handleCheckedChange">
                        <el-checkbox
                            v-for="item in sec.items"
                            :key="item.gradeLevel"
                            :label="item.gradeName"
                            class="batch-card">
                            <div class="batch-card-inner">
                                <div class="batch-card-head">
                                    <span class="batch-card-name">{{ item.gradeName }}</span>
                                </div>
                                <div class="batch-card-meta">
                                    <span>级别 {{ item.gradeLevel }}</span>
                                    <span>排序 {{ item.sort }}</span>
                                </div>
                            </div>
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <div slot="footer" class="batch-footer">
                <span class="batch-footer-tip" v-if="checkedGrades.length > 0">将新增 <b>{{ checkedGrades.length }}</b> 个年级</span>
                <span v-else></span>
                <div>
                    <el-button @click="batchDialogVisible = false">取消</el-button>
                    <el-button type="primary" icon="el-icon-check" @click="submitBatch" :loading="batchLoading" :disabled="checkedGrades.length === 0">确认新增</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { reqGradePage, reqGradeDetail, reqGradeInsert, reqGradeUpdate, reqGradeDelete, reqGradeBatchInsert } from '@/api/education/grade'

export default {
    name: 'Grade',
    data() {
        return {
            list: [],
            total: 0,
            tableLoading: false,
            submitLoading: false,
            stageMap: { 1: '小学', 2: '初中', 3: '高中' },
            query: {
                currentPage: 1,
                pageSize: 10,
                gradeName: '',
                gradeLevel: null,
                stage: null,
                status: null
            },
            dialogVisible: false,
            dialogTitle: '',
            // 批量新增相关
            batchDialogVisible: false,
            batchLoading: false,
            checkedGrades: [],
            gradeOptions: [
                { gradeName: '三年级', gradeLevel: 3, stage: 1, sort: 3 },
                { gradeName: '四年级', gradeLevel: 4, stage: 1, sort: 4 },
                { gradeName: '五年级', gradeLevel: 5, stage: 1, sort: 5 },
                { gradeName: '六年级', gradeLevel: 6, stage: 1, sort: 6 },
                { gradeName: '初一', gradeLevel: 7, stage: 2, sort: 7 },
                { gradeName: '初二', gradeLevel: 8, stage: 2, sort: 8 },
                { gradeName: '初三', gradeLevel: 9, stage: 2, sort: 9 },
                { gradeName: '高一', gradeLevel: 10, stage: 3, sort: 10 },
                { gradeName: '高二', gradeLevel: 11, stage: 3, sort: 11 },
                { gradeName: '高三', gradeLevel: 12, stage: 3, sort: 12 }
            ],
            formData: {
                id: null,
                gradeName: '',
                gradeLevel: 1,
                stage: 1,
                description: '',
                sort: 0,
                status: 1,
                remark: ''
            },
            rules: {
                gradeName: [
                    { required: true, message: '请输入年级名称', trigger: 'blur' },
                    { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
                ],
                gradeLevel: [
                    { required: true, message: '请输入年级级别', trigger: 'blur' }
                ],
                stage: [
                    { required: true, message: '请选择学段', trigger: 'change' }
                ]
            }
        }
    },
    created() {
        this.load()
    },
    computed: {
        // 按学段分组：小学(1) / 初中(2) / 高中(3)
        stageSections() {
            const order = [1, 2, 3]
            return order.map(stage => ({
                stage,
                label: this.stageMap[stage],
                items: this.gradeOptions.filter(item => item.stage === stage)
            }))
        },
        // 是否已全选全部内置年级
        isAllChecked() {
            return this.checkedGrades.length === this.gradeOptions.length
        },
        // 根据所选学段返回年级级别的合理范围
        stageRange() {
            const map = {
                1: { min: 1, max: 6, def: 1 },
                2: { min: 7, max: 9, def: 7 },
                3: { min: 10, max: 12, def: 10 }
            }
            return map[this.formData.stage] || { min: 1, max: 12, def: 1 }
        }
    },
    methods: {
        async load() {
            this.tableLoading = true
            try {
                const data = await reqGradePage(this.query)
                this.list = data.records || []
                this.total = data.total || 0
            } catch (e) {
                this.$message.error('加载年级列表失败')
                console.error(e)
            } finally {
                this.tableLoading = false
            }
        },
        handleSearch() {
            this.query.currentPage = 1
            this.load()
        },
        handleReset() {
            this.query = {
                currentPage: 1,
                pageSize: 10,
                gradeName: '',
                gradeLevel: null,
                stage: null,
                status: null
            }
            this.load()
        },
        currentChange(num) {
            this.query.currentPage = num
            this.load()
        },
        sizeChange(size) {
            this.query.pageSize = size
            this.query.currentPage = 1
            this.load()
        },
        btnInsert(row) {
            if (row) {
                this.dialogTitle = '编辑年级'
                this.formData = {
                    id: row.id,
                    gradeName: row.gradeName || '',
                    gradeLevel: row.gradeLevel || 1,
                    stage: row.stage || 1,
                    description: row.description || '',
                    sort: row.sort || 0,
                    status: row.status != null ? row.status : 1,
                    remark: row.remark || ''
                }
            } else {
                this.dialogTitle = '新增年级'
                this.formData = {
                    id: null,
                    gradeName: '',
                    gradeLevel: 1,
                    stage: 1,
                    description: '',
                    sort: 0,
                    status: 1,
                    remark: ''
                }
            }
            this.$nextTick(() => {
                if (this.$refs.formData) {
                    this.$refs.formData.clearValidate()
                }
            })
            this.dialogVisible = true
        },
        // 切换学段：自动校正年级级别到该学段合理范围
        onStageChange() {
            const { min, max, def } = this.stageRange
            if (this.formData.gradeLevel < min || this.formData.gradeLevel > max) {
                this.formData.gradeLevel = def
            }
        },
        closeDialog() {
            this.$refs.formData && this.$refs.formData.clearValidate()
        },
        async btnDelete(id) {
            try {
                await this.$confirm('确定要删除该年级吗？删除后不可恢复。', '删除确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                await reqGradeDelete(id)
                this.$message.success('删除成功')
                this.load()
            } catch (e) {
                if (e !== 'cancel') {
                }
            }
        },
        submitForm() {
            this.$refs.formData.validate(async valid => {
                if (!valid) return

                this.submitLoading = true
                try {
                    if (this.formData.id) {
                        await reqGradeUpdate(this.formData)
                    } else {
                        await reqGradeInsert(this.formData)
                    }
                    this.$message.success('操作成功')
                    this.dialogVisible = false
                    this.load()
                } catch (e) {
                    this.$message.error(e.message || '操作失败')
                } finally {
                    this.submitLoading = false
                }
            })
        },
        // 批量新增相关方法
        openBatchDialog() {
            // 默认全选所有年级，减少用户操作
            this.checkedGrades = this.gradeOptions.map(item => item.gradeName)
            this.batchDialogVisible = true
        },
        closeBatchDialog() {
            this.batchDialogVisible = false
        },
        // 一键全选/取消全部年级
        toggleAllGrades() {
            this.checkedGrades = this.isAllChecked ? [] : this.gradeOptions.map(item => item.gradeName)
        },
        // 某学段下已选中的年级名称集合
        selectedOfStage(stage) {
            const names = this.gradeOptions
                .filter(item => item.stage === stage)
                .map(item => item.gradeName)
            return names.filter(name => this.checkedGrades.includes(name))
        },
        isStageCheckedAll(stage) {
            const names = this.gradeOptions
                .filter(item => item.stage === stage)
                .map(item => item.gradeName)
            return names.length > 0 && names.every(name => this.checkedGrades.includes(name))
        },
        isStageIndeterminate(stage) {
            const selected = this.selectedOfStage(stage)
            return selected.length > 0 && !this.isStageCheckedAll(stage)
        },
        toggleStageAll(stage, val) {
            const names = this.gradeOptions
                .filter(item => item.stage === stage)
                .map(item => item.gradeName)
            if (val) {
                // 全选该学段：合并已选
                this.checkedGrades = Array.from(new Set([...this.checkedGrades, ...names]))
            } else {
                // 取消该学段：移除
                this.checkedGrades = this.checkedGrades.filter(name => !names.includes(name))
            }
        },
        handleCheckedChange() {
            // 仅用于触发视图更新，分段状态由计算属性实时得出
        },
        submitBatch() {
            if (this.checkedGrades.length === 0) {
                this.$message.warning('请至少选择一个年级')
                return
            }
            // 根据勾选名称映射出完整年级对象（级别/学段/排序自动填充）
            const selected = this.gradeOptions.filter(item => this.checkedGrades.includes(item.gradeName))
            const payload = selected.map(item => ({
                gradeName: item.gradeName,
                gradeLevel: item.gradeLevel,
                stage: item.stage,
                sort: item.sort,
                status: 1
            }))
            this.batchLoading = true
            reqGradeBatchInsert(payload)
                .then(() => {
                    this.$message.success('批量新增成功')
                    this.batchDialogVisible = false
                    this.load()
                })
                .catch(e => {
                    this.$message.error(e.message || '批量新增失败')
                })
                .finally(() => {
                    this.batchLoading = false
                })
        }
    }
}
</script>

<style scoped lang="scss">
.grade-page {
    padding: 0;

    .filter-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 16px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .table-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 14px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .card-header-left {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 15px;
            font-weight: 600;
            color: #303133;

            i {
                font-size: 18px;
                color: #409eff;
            }

            .header-sub {
                font-size: 13px;
                font-weight: 500;
                color: #909399;
            }

            .total-badge {
                font-size: 13px;
                font-weight: 400;
                color: #909399;
                margin-left: 8px;

                b {
                    color: #409eff;
                    font-size: 16px;
                    font-weight: 600;
                }
            }
        }

        .card-header-right {
            display: flex;
            align-items: center;
            gap: 10px;
        }
    }

    .filter-form {
        padding: 4px 0 0;

        ::v-deep .el-form-item {
            margin-bottom: 8px;
        }
    }

    .pagination-wrapper {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }

    .action-btns {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        white-space: nowrap;

        .el-button + .el-button {
            margin-left: 0;
        }
    }

    ::v-deep .el-divider--vertical {
        height: 1.2em;
        margin: 0 4px;
    }

    ::v-deep .el-table {
        th {
            background: #fafafa;
            color: #606266;
            font-weight: 600;
            font-size: 13px;
        }

        td {
            font-size: 13px;
        }

        .el-tag--plain {
            font-weight: 500;
        }
    }

    ::v-deep .el-dialog {
        border-radius: 6px;
        overflow: hidden;

        .el-dialog__header {
            padding: 16px 24px;
            border-bottom: 1px solid #ebeef5;

            .el-dialog__title {
                font-size: 16px;
                font-weight: 600;
                color: #303133;
            }
        }

        .el-dialog__body {
            padding: 24px 30px 8px;
        }

        .el-dialog__footer {
            padding: 14px 30px;
            border-top: 1px solid #ebeef5;
        }
    }

    // ===== 批量弹窗头部 =====
    .batch-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .batch-header-left {
            display: flex;
            align-items: center;
            gap: 12px;
        }

        .batch-header-icon {
            width: 38px;
            height: 38px;
            border-radius: 10px;
            background: rgba(255, 255, 255, 0.22);
            display: flex;
            align-items: center;
            justify-content: center;

            i {
                font-size: 20px;
                color: #fff;
            }
        }

        .batch-header-title {
            font-size: 16px;
            font-weight: 600;
            color: #fff;
            line-height: 1.4;
        }

        .batch-header-desc {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.85);
            margin-top: 2px;
        }

        .batch-header-close {
            font-size: 18px;
            color: rgba(255, 255, 255, 0.85);
            cursor: pointer;
            transition: all 0.2s;

            &:hover {
                color: #fff;
                transform: rotate(90deg);
            }
        }
    }

    // ===== 快捷操作条 =====
    .batch-quickbar {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: 10px 20px;
        padding: 12px 16px;
        margin-bottom: 16px;
        background: linear-gradient(135deg, #f3faf7 0%, #f7fbf9 100%);
        border: 1px solid #e3f1ec;
        border-radius: 10px;

        .quick-item {
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .quick-label {
            font-size: 13px;
            color: #5a6b64;
            font-weight: 500;
            white-space: nowrap;
        }

        ::v-deep .el-button--mini {
            padding: 6px 12px;
            border-radius: 6px;
        }

        .batch-count {
            font-size: 13px;
            color: #8a9a93;

            b {
                color: #2e8b74;
                font-size: 16px;
                margin: 0 2px;
            }
        }
    }

    .batch-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .batch-footer-tip {
            font-size: 13px;
            color: #8a9a93;

            b {
                color: #2e8b74;
                font-size: 16px;
                margin: 0 2px;
            }
        }
    }

    ::v-deep .batch-grade-dialog {
        border-radius: 12px;

        .el-dialog__header {
            padding: 16px 22px;
            background: linear-gradient(135deg, #2e8b74 0%, #4fae93 100%);
            border-bottom: none;
        }

        .el-dialog__body {
            padding: 20px 24px 12px;
            max-height: 62vh;
            overflow-y: auto;
        }

        .el-dialog__footer {
            padding: 12px 24px;
            border-top: 1px solid #ebeef5;
            background: #fafbfc;
        }

        ::v-deep .el-button--primary {
            background-color: #2e8b74;
            border-color: #2e8b74;

            &:hover, &:focus {
                background-color: #3aa98a;
                border-color: #3aa98a;
            }

            &.is-disabled {
                background-color: #a9d3c8;
                border-color: #a9d3c8;
            }
        }
    }

    ::v-deep .grade-dialog {
        border-radius: 12px;

        .el-dialog__header {
            padding: 16px 22px;
            background: linear-gradient(135deg, #2e8b74 0%, #4fae93 100%);
            border-bottom: none;

            .el-dialog__title {
                color: #fff;
                font-size: 16px;
                font-weight: 600;
            }

            .el-dialog__headerbtn .el-dialog__close {
                color: rgba(255, 255, 255, 0.85);

                &:hover {
                    color: #fff;
                }
            }
        }

        ::v-deep .el-button--primary {
            background-color: #2e8b74;
            border-color: #2e8b74;

            &:hover, &:focus {
                background-color: #3aa98a;
                border-color: #3aa98a;
            }
        }
    }

    .batch-sections {
        display: flex;
        flex-direction: column;
        gap: 18px;
    }

    .batch-section {
        & + .batch-section {
            padding-top: 16px;
            border-top: 1px dashed #ebeef5;
        }

        .batch-section-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 12px;
        }

        .batch-section-title {
            display: inline-flex;
            align-items: center;
            font-size: 14px;
            font-weight: 600;

            .batch-stage-dot {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                margin-right: 8px;
            }

            &.stage-1 {
                color: #67c23a;
                .batch-stage-dot { background: #67c23a; }
            }
            &.stage-2 {
                color: #e6a23c;
                .batch-stage-dot { background: #e6a23c; }
            }
            &.stage-3 {
                color: #909399;
                .batch-stage-dot { background: #909399; }
            }
        }
    }

    .batch-group {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;

        ::v-deep .el-checkbox {
            margin-right: 0;
        }

        .batch-card {
            width: calc(25% - 9px);
            height: auto;
            margin-right: 0;

            ::v-deep .el-checkbox__input {
                position: absolute;
                top: 10px;
                right: 10px;
                z-index: 1;
            }

            ::v-deep .el-checkbox__label {
                padding-left: 0;
                width: 100%;
                line-height: 1.4;
            }

            // 未选中卡片外观
            .batch-card-inner {
                border: 1px solid #ebeef5;
                border-radius: 8px;
                padding: 12px 14px;
                background: #fff;
                transition: all 0.2s;
                cursor: pointer;
            }

            &:hover .batch-card-inner {
                border-color: #b9ddd2;
                box-shadow: 0 2px 8px rgba(46, 139, 116, 0.12);
            }

            // 选中状态高亮
            &.is-checked .batch-card-inner {
                border-color: #2e8b74;
                background: #e8f5f0;
                box-shadow: 0 2px 8px rgba(46, 139, 116, 0.18);
            }

            .batch-card-head {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 8px;
            }

            .batch-card-name {
                font-size: 15px;
                font-weight: 600;
                color: #303133;
            }

            .batch-card-meta {
                display: flex;
                gap: 12px;
                font-size: 12px;
                color: #909399;
            }
        }
    }
}

@media screen and (max-width: 768px) {
    .grade-page {
        .card-header {
            flex-wrap: wrap;
            gap: 8px;
        }

        .filter-form {
            ::v-deep .el-form--inline .el-form-item {
                display: block;
                width: 100%;
                margin-bottom: 12px;
            }

            ::v-deep .el-form--inline .el-form-item .el-form-item__content {
                width: 100%;
            }

            ::v-deep .el-form--inline .el-form-item .el-form-item__content .el-select,
            ::v-deep .el-form--inline .el-form-item .el-form-item__content .el-input {
                width: 100% !important;
            }
        }

        ::v-deep .el-card__body {
            padding: 12px;
        }

        ::v-deep .el-table {
            overflow-x: auto;
            display: block;
        }

        ::v-deep .el-dialog {
            width: 95% !important;
            margin: 10px auto !important;
        }

        ::v-deep .el-dialog__body {
            padding: 16px;
        }

        ::v-deep .el-dialog__footer {
            padding: 12px 16px;
        }

        ::v-deep .el-pagination {
            white-space: normal;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 4px;
        }

        ::v-deep .el-pagination .el-pagination__total,
        ::v-deep .el-pagination .el-pagination__sizes {
            margin-right: 0;
        }

        ::v-deep .el-pagination button,
        ::v-deep .el-pagination .el-pager li {
            min-width: 28px;
            height: 28px;
            line-height: 28px;
            font-size: 12px;
        }
    }
}
</style>
